import { useState, useCallback } from 'react'

export const useValidateForm = <T>(
  formState: T,
  setFormState: (data: T) => void,
  validate: any
) => {
  const [result, setResult] = useState(validate.get())
  const runValidate = useCallback(
    (name: keyof T, value: any, validateName: string | undefined) => {
      const res = validate(
        {
          ...formState,
          [name]: value
        },
        validateName ?? name
      )
      setResult(res)
    },
    [formState, validate]
  )

  const runValidateAll = useCallback(() => {
    const res = validate(formState)
    setResult(res)
    return res
  }, [formState, validate])

  const handleChange = useCallback(
    (name: keyof T, value: any, validateName: string | undefined) => {
      setFormState({ ...formState, ...{ [name]: value } })
      runValidate(name, value, validateName)
    },
    [formState, runValidate]
  )

  const handleChangeFactory = useCallback(
    (name: keyof T, validateName?: string) => {
      return (value: any) => handleChange(name, value, validateName)
    },
    [handleChange]
  )

  return [result, handleChangeFactory, runValidateAll] as [
    typeof result,
    typeof handleChangeFactory,
    typeof runValidateAll
  ]
}
